"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Col = _interopRequireDefault(require("../baseComponents/Col"));
var _Row = _interopRequireDefault(require("../baseComponents/Row"));
var _TextTruncate = _interopRequireDefault(require("../baseComponents/TextTruncate"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Header = function Header(props) {
  var extraComponents = props.toolComponents.map(function (element, index) {
    return /*#__PURE__*/_react["default"].createElement(_Col["default"], {
      key: index,
      className: "headerTool"
    }, " ", element, " ");
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "header-component"
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    middle: "xs"
  }, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 6,
    className: "title"
  }, /*#__PURE__*/_react["default"].createElement("h2", null, /*#__PURE__*/_react["default"].createElement(_TextTruncate["default"], {
    text: props.title,
    limit: props.titleLengthLimit
  })), props.desc && /*#__PURE__*/_react["default"].createElement("p", {
    className: "lead"
  }, /*#__PURE__*/_react["default"].createElement(_TextTruncate["default"], {
    text: props.desc,
    limit: props.descLengthLimit
  }))), /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 6,
    className: "toolComponents end-xs "
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    end: "xs",
    middle: "xs",
    className: "toolComponentsContainer"
  }, extraComponents))));
};
Header.propTypes = {
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].object]),
  desc: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].object]),
  titleLengthLimit: _propTypes["default"].number,
  descLengthLimit: _propTypes["default"].number,
  toolComponents: _propTypes["default"].array
};
Header.defaultProps = {
  title: 'Header',
  desc: null,
  titleLengthLimit: 85,
  descLengthLimit: 85,
  toolComponents: []
};
var _default = exports["default"] = Header;